export var Aggregator;
(function (Aggregator) {
    Aggregator["UNKNOWN"] = "Unknown";
    Aggregator["UNSUPPORTED"] = "Unsupported";
    Aggregator["ZERO_EX"] = "0x";
    Aggregator["ONE_INCH"] = "1Inch";
    Aggregator["PARASWAP"] = "Paraswap";
    Aggregator["ODOS"] = "Odos";
    Aggregator["OPEN_OCEAN"] = "OpenOcean";
    Aggregator["KYBERSWAP"] = "KyberSwap";
    Aggregator["JUPITER"] = "Jupiter";
    Aggregator["NO_SWAP"] = "NoSwap";
    Aggregator["UNISWAP_V3"] = "UniswapV3";
    Aggregator["UNISWAP_V2"] = "UniswapV2";
    Aggregator["DEBRIDGE"] = "DeBridge";
    Aggregator["AFTERMATH"] = "Aftermath";
    Aggregator["OKX"] = "OKX";
    Aggregator["RAYDIUM"] = "Raydium";
    Aggregator["PUMPFUN"] = "PumpFun";
    Aggregator["RAYDIUM_V2"] = "RaydiumV2";
})(Aggregator || (Aggregator = {}));
export var Bridge;
(function (Bridge) {
    Bridge["UNKNOWN"] = "Unknown";
    Bridge["DEBRIDGE"] = "DeBridge";
    Bridge["OKX"] = "OKX";
    Bridge["GENIUS"] = "Genius";
    Bridge["WORMHOLE"] = "Wormhole";
})(Bridge || (Bridge = {}));
export var TokenType;
(function (TokenType) {
    TokenType["EVM"] = "EVM";
    TokenType["NATIVE_SOL"] = "NativeSOL";
    TokenType["SPL"] = "SPL";
    TokenType["Token2022"] = "Token202";
    TokenType["COIN"] = "Coin";
    TokenType["Unknown"] = "Unknown";
})(TokenType || (TokenType = {}));
export var PriorityFeeLevels;
(function (PriorityFeeLevels) {
    PriorityFeeLevels[PriorityFeeLevels["CUSTOM"] = 0] = "CUSTOM";
    PriorityFeeLevels[PriorityFeeLevels["LOW"] = -1] = "LOW";
    PriorityFeeLevels[PriorityFeeLevels["MEDIUM"] = -2] = "MEDIUM";
    PriorityFeeLevels[PriorityFeeLevels["HIGH"] = -3] = "HIGH";
})(PriorityFeeLevels || (PriorityFeeLevels = {}));
export var BlockchainType;
(function (BlockchainType) {
    BlockchainType["EVM"] = "EVM";
    BlockchainType["SVM"] = "SVM";
    BlockchainType["MOVE"] = "MOVE";
    BlockchainType["UNKNOWN"] = "UNKNOWN";
})(BlockchainType || (BlockchainType = {}));
export var BlockchanTypeName;
(function (BlockchanTypeName) {
    BlockchanTypeName["EVM"] = "EVM";
    BlockchanTypeName["SVM"] = "Solana";
    BlockchanTypeName["MOVE"] = "Move";
    BlockchanTypeName["UNKNOWN"] = "Unknown";
})(BlockchanTypeName || (BlockchanTypeName = {}));
export var GeniusOrderType;
(function (GeniusOrderType) {
    GeniusOrderType["SWAP_EVM"] = "SWAP_EVM";
    GeniusOrderType["SWAP_SOLANA"] = "SWAP_SOLANA";
    GeniusOrderType["SWAP_EVM_SPONSORED"] = "SWAP_EVM_SPONSORED";
    GeniusOrderType["SWAP_SOLANA_SPONSORED"] = "SWAP_SOLANA_SPONSORED";
    GeniusOrderType["SWAP_FLASHBOTS"] = "SWAP_FLASHBOTS";
    GeniusOrderType["WITHDRAW_EVM"] = "WITHDRAW_EVM";
    GeniusOrderType["WITHDRAW_SOLANA"] = "WITHDRAW_SOLANA";
    GeniusOrderType["WITHDRAW_EVM_SPONSORED"] = "WITHDRAW_EVM_SPONSORED";
    GeniusOrderType["WITHDRAW_SOLANA_SPONSORED"] = "WITHDRAW_SOLANA_SPONSORED";
    GeniusOrderType["SWAP_SUI"] = "SWAP_SUI";
    GeniusOrderType["SWAP_SPONSORED_SUI"] = "SWAP_SPONSORED_SUI";
    GeniusOrderType["WITHDRAW_SUI"] = "WITHDRAW_SUI";
    GeniusOrderType["WITHDRAW_SUI_SPONSORED"] = "WITHDRAW_SUI_SPONSORED";
    GeniusOrderType["SUI_WORMHOLE"] = "SUI_WORMHOLE";
    GeniusOrderType["SOLANA_WORMHOLE"] = "SOLANA_WORMHOLE";
    GeniusOrderType["EVM_WORMHOLE"] = "EVM_WORMHOLE";
    GeniusOrderType["SUI_WORMHOLE_SPONSORED"] = "SUI_WORMHOLE_SPONSORED";
    GeniusOrderType["SOLANA_WORMHOLE_SPONSORED"] = "SOLANA_WORMHOLE_SPONSORED";
    GeniusOrderType["EVM_WORMHOLE_SPONSORED"] = "EVM_WORMHOLE_SPONSORED";
})(GeniusOrderType || (GeniusOrderType = {}));
